export default __webpack_public_path__ + "static/media/icon-discount.6726e91d.svg";